/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {
    @Serenity.Decorators.registerClass()    
    @Serenity.Decorators.responsive()
    export class UserDialog extends _Ext.DialogBase<UserRow, any> {
        protected getFormKey() { return UserForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }

        protected form = new UserForm(this.idPrefix);

        constructor() {
            super();
            q.hideCaption(this.form.UserImage);
            q.HideCategoryLable(this.element);
            q.SetCategoryEightColumn(this.form.Type);
            q.SetCategoryFourColumn(this.form.UserImage);
            q.SetCategoryFullWidth(this.form.Password);
            this.form.Password.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value.length < 7)
                    return "Password must be at least 7 characters!";
            });

            this.form.PasswordConfirm.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value != this.form.PasswordConfirm.value)
                    return "The passwords entered doesn't match!";
            });
            this.form.Type.changeSelect2(e => {
                if (this.form.Type.value == "User") {
                    // Set read only to true for a field
                    Serenity.EditorUtils.setReadOnly(this.form.PartyId, true);
                    Serenity.EditorUtils.setRequired(this.form.PartyId, false);
                    Serenity.EditorUtils.setReadonly(this.form.HasEdit.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.HasAuth.element, false);
                    Serenity.EditorUtils.setReadonly(this.form.HasCatalogueAccess.element, false);
                    this.form.HasCatalogueAccess.value = false;
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.PartyId, false);
                    Serenity.EditorUtils.setRequired(this.form.PartyId, true);
                    Serenity.EditorUtils.setReadonly(this.form.HasEdit.element, true);
                    Serenity.EditorUtils.setReadonly(this.form.EditPassword.element, true);
                    Serenity.EditorUtils.setReadonly(this.form.HasAuth.element, true);
                    Serenity.EditorUtils.setReadonly(this.form.AuthPassword.element, true);
                    Serenity.EditorUtils.setReadonly(this.form.HasCatalogueAccess.element, true);
                    this.form.HasCatalogueAccess.value = true;
                    this.form.HasEdit.value = false;
                    this.form.HasAuth.value = false;
                    this.form.EditPassword.value = "";
                    this.form.AuthPassword.value = "";
                }
            });
            this.form.HasEdit.changeSelect2(e => {
                if (this.form.HasEdit.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.EditPassword, false);
                    Serenity.EditorUtils.setRequired(this.form.EditPassword, true);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.EditPassword, true);
                    Serenity.EditorUtils.setRequired(this.form.EditPassword, false);
                }
            });
            this.form.HasAuth.changeSelect2(e => {
                if (this.form.HasAuth.value == true) {
                    Serenity.EditorUtils.setReadOnly(this.form.AuthPassword, false);
                    Serenity.EditorUtils.setRequired(this.form.AuthPassword, true);
                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.AuthPassword, true);
                    Serenity.EditorUtils.setRequired(this.form.AuthPassword, false);
                }
            });
        }
        protected onDialogOpen() {
            if (this.form.HasEdit.value == true) {
                Serenity.EditorUtils.setReadOnly(this.form.EditPassword, false);
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.EditPassword, true);
            }
            if (this.form.HasAuth.value == true) {
                Serenity.EditorUtils.setReadOnly(this.form.AuthPassword, false);
            } else {
                Serenity.EditorUtils.setReadOnly(this.form.AuthPassword, true);
            }

        }
        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            buttons.push({
                title: Q.text('Site.UserDialog.EditRolesButton'),
                cssClass: 'edit-roles-button',
                icon: 'fa-users text-blue',
                onClick: () => {
                    new UserRoleDialog({
                        userID: this.entity.UserId,
                        username: this.entity.Username
                    }).dialogOpen();
                }
            });

            buttons.push({
                title: Q.text('Site.UserDialog.EditPermissionsButton'),
                cssClass: 'edit-permissions-button',
                icon: 'fa-lock text-green',
                onClick: () => {
                    new UserPermissionDialog({
                        userID: this.entity.UserId,
                        username: this.entity.Username
                    }).dialogOpen();
                }
            });

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('edit-roles-button').toggleClass('disabled', this.isNewOrDeleted());
            this.toolbar.findButton("edit-permissions-button").toggleClass("disabled", this.isNewOrDeleted());
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // these fields are only required in new record mode
            this.form.Password.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
            this.form.PasswordConfirm.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
        }
        //private confirmBeforeDelete(oldEvt, e) {
        //    let self = this;
        //    var id = UserRow.getLookup().items.filter(x => x.Username == this.form.Username.value)[0];
        //    var refid = OMSOrderMasterRow.getLookup().items.filter(x => x.PartyId == id.LedgerId)[0];
        //    if (refid != null) {
        //        if (refid.PartyId != null || refid.PartyId > 0) {
        //            Q.alert("Customer is in use, Cannot delete");
        //            return;
        //        }
        //    } else {
        //        CustomerService.Delete(
        //            {

        //                EntityId: this.entityId
        //            }, response => {
        //                Serenity.SubDialogHelper.triggerDataChange(self);
        //                self.dialogClose();
        //                window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
        //            });
        //    }

        //}
    }
}